module.exports = {
  AvatarPlayer: {
    PluginName: "Avatar",
    avatar: "Avatar",
    avatarName: "Nombre del avatar",
    poster: "Imagen",
    framing: "Encuadre",
    focalX: "Foco horizontal",
    focalY: "Foco vertical",
    radius: "Radio de esquina",
    box_style: "Estilo de caja",
    border: "Borde",
    opacity: "Opacidad",
  },
};
